import { ProblemDetail } from '@core/api/contracts';

export type CurrentUserProblemMessage =
  | 'authentication-required'
  | 'registration-not-allowed'
  | 'email-claim-required'
  | 'generic-access-denied';

export function mapCurrentUserProblemDetail(problem: ProblemDetail | null | undefined): CurrentUserProblemMessage {
  switch (problem?.code) {
    case 'AUTHENTICATION_REQUIRED':
      return 'authentication-required';
    case 'REGISTRATION_NOT_ALLOWED':
      return 'registration-not-allowed';
    case 'EMAIL_CLAIM_REQUIRED':
      return 'email-claim-required';
    default:
      return 'generic-access-denied';
  }
}
